import Vue from 'vue'
import Router from 'vue-router'
import ContainHeaderLayout from '@/components/ContainHeaderLayout/ContainHeaderLayout'

Vue.use(Router)

const constantRouterMap = [
  {
    path: '/',
    name: 'ContainHeaderLayout',
    component: ContainHeaderLayout
  },
  // 选择服务类型
  {
    path: '/Service',
    component: ContainHeaderLayout,
    name: 'Service',
    redirect: '/Service',
    children: [
      {
        path: '',
        component: () => import('@/components/Service/Service'),
        meta: { title: '选择服务类型' }
      },
      {
        path: 'ServiceApplication/:type',
        component: () => import('@/components/ServiceApplication/ServiceApplication'),
        name: 'ServiceApplication',
        meta: { title: '服务申请' }
      },
      {
        path: 'List',
        component: () => import('@/components/Service/List'),
        name: 'ServiceList',
        meta: { title: '服务单列表' }
      },
      {
        path: 'Info/:id/:serviceType',
        component: () => import('@/components/Service/Info'),
        name: 'ServiceInfo',
        meta: { title: '服务单详情' }
      }
    ]
  },
  // 填写保修信息
  {
    path: '/Repair',
    component: ContainHeaderLayout,
    name: 'Repair',
    redirect: '/Repair',
    children: [
      {
        path: 'Add',
        component: () => import('@/components/Repair/Repair'),
        name: 'RepairAdd',
        meta: { title: '快速报修' }
      },
      {
        path: 'List',
        component: () => import('@/components/Repair/List'),
        name: 'RepairList',
        meta: { title: '故障单列表' }
      },
      {
        path: 'Info/:id',
        component: () => import('@/components/Repair/Info'),
        name: 'RepairInfo',
        meta: { title: '故障单详情' }
      }
    ]
  },
  // 查询信息
  {
    path: '/WarrantyEnquiry',
    component: ContainHeaderLayout,
    redirect: '/WarrantyEnquiry',
    children: [
      {
        path: '',
        component: () => import('@/components/WarrantyEnquiry/WarrantyEnquiry'),
        name: 'WarrantyEnquiry',
        meta: { title: '保修查询' }
      }
    ]
  },
  {
    path: '/CompanyInfo',
    name: 'CompanyInfo',
    component: () => import('@/components/CompanyInfo/CompanyInfo'),
    meta: { title: '服务电话' }
  },
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    component: () => import('@/components/PersonalCenter/PersonalCenter'),
    meta: { title: '个人中心' }
  },
  {
    path: '/PersonalInfo',
    name: 'PersonalInfo',
    component: () => import('@/components/PersonalInfo/PersonalInfo'),
    meta: { title: '个人资料' }
  },
  {
    path: '/MyServerList',
    component: ContainHeaderLayout,
    children: [
      {
        path: '',
        component: () => import('@/components/ListTypeSelect/ListTypeSelect'),
        name: 'ListTypeSelect',
        meta: { title: '我的服务单' }
      }
    ]
  },
  {
    path: '/Diagnoses',
    component: ContainHeaderLayout,
    name: 'Diagnoses',
    redirect: '/Diagnoses',
    children: [
      {
        path: 'list/:id',
        component: () => import('@/components/Diagnoses/Detail'),
        meta: { title: '服务满意度调查' }
      },
      {
        path: 'Success',
        name: 'Success',
        component: () => import('@/components/Diagnoses/EvaluationSuccess'),
        meta: { title: '服务满意度调查成功' }
      },
      {
        path: 'Completion',
        name: 'Completion',
        component: () => import('@/components/Diagnoses/Completion'),
        meta: { title: '已完成调查' }
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/components/ErrorPage/404'),
    meta: { title: '404' }
  }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js